export default "__VITE_ASSET__wB2Qy4Re__"